import React, { useContext } from "react";
import { Field } from "react-final-form";
import { Textarea } from "components/ui/textarea";
import { Label } from "components/ui/label";
import { IntlContext } from "context";

type OfferMessageSectionProps = {
    isDirectOffer?: boolean;
};

const OfferMessageSection: React.FC<OfferMessageSectionProps> = ({ isDirectOffer = false }) => {
    const intl = useContext(IntlContext);
    const placeholderKey = isDirectOffer
        ? "booking.messages.offer.message.placeholder_direct"
        : "booking.messages.offer.message.placeholder";

    return (
        <section className="flex flex-col gap-3">
            <Label htmlFor="offer-message" className="text-xs font-medium text-slate-500">
                {intl.formatMessage("booking.messages.offer.message.label")}
            </Label>
            <Field name="message">
                {({ input }) => (
                    <Textarea
                        {...input}
                        id="offer-message"
                        autoComplete="off"
                        maxLength={500}
                        required
                        className="min-h-[116px] rounded-xl border-slate-200"
                        placeholder={intl.formatMessage(placeholderKey)}
                    />
                )}
            </Field>
        </section>
    );
};

export default OfferMessageSection;
